import { getSessionOrganizationId } from '../../../shell/session/sessionOrganization';
import { normalizeProductCode } from '../../domain/catalogValidation';
export type ProductBySkuRow = {
  id: string;
  name: string;
  price: number;
  sku: string;
  barcode: string | null;
  categoryId: string | null;
  itemType: string;
  isActive: number;
  brandId: string | null;
  internalNotes: string | null;
  preferredSupplierId: string | null;
  supplierItemCode: string | null;
};

export async function findProductBySkuFromWebSnapshot(
  normalizedSku: string,
  organizationId: string
): Promise<ProductBySkuRow | null> {
  const { getCatalogRamSnapshotCache } = await import('../catalogRamSnapshotCache');
  const cache = getCatalogRamSnapshotCache();
  if (!cache?.products.length) return null;

  const row = cache.products.find((p) => {
    if (p.organization_id && String(p.organization_id) !== organizationId) return false;
    const productSku = normalizeProductCode(String(p.sku ?? '').trim());
    return productSku === normalizedSku;
  });
  if (!row) return null;

  return {
    id: row.id,
    name: row.name ?? '',
    price: Number(row.price ?? 0),
    sku: String(row.sku ?? '').trim(),
    barcode:
      row.barcode != null && String(row.barcode).trim() !== '' ? String(row.barcode).trim() : null,
    categoryId:
      row.category_id != null && String(row.category_id).trim() !== ''
        ? String(row.category_id).trim()
        : null,
    itemType: row.item_type === 'service' ? 'service' : 'physical',
    isActive: row.is_active === false ? 0 : 1,
    brandId:
      row.brand_id != null && String(row.brand_id).trim() !== '' ? String(row.brand_id).trim() : null,
    internalNotes:
      row.internal_notes != null && String(row.internal_notes).trim() !== ''
        ? String(row.internal_notes).trim()
        : null,
    preferredSupplierId:
      row.preferred_supplier_id != null && String(row.preferred_supplier_id).trim() !== ''
        ? String(row.preferred_supplier_id).trim()
        : null,
    supplierItemCode:
      row.supplier_item_code != null && String(row.supplier_item_code).trim() !== ''
        ? String(row.supplier_item_code).trim()
        : null,
  };
}

export async function findProductBySku(sku: string): Promise<ProductBySkuRow | null> {
  const organizationId = await getSessionOrganizationId();
  if (!organizationId) return null;
  const normalized = normalizeProductCode(sku);
  if (!normalized) return null;

  return findProductBySkuFromWebSnapshot(normalized, organizationId);
}
